import classNames from 'classnames'
import { type FC, useEffect, useState } from 'react'
import styles from './PaginationDot.module.scss'
import type { PaginationDotProps } from './types'

const TRANSITION_SLIDES_DURATION = 800

const PaginationDot: FC<PaginationDotProps> = ({
  edge,
  rtl,
  selected,
  variant,
  unselected,
  ...props
}) => {
  const [transformEdge, setTransformEdge] = useState({})
  useEffect(() => {
    const timeoutTransformEdge = setTimeout(
      () => setTransformEdge(edge ? { transform: 'scale(0.5)' } : {}),
      TRANSITION_SLIDES_DURATION
    )
    return () => timeoutTransformEdge && clearTimeout(timeoutTransformEdge)
  }, [edge])

  return (
    <button
      className={classNames({
        [styles['pintxo-pagination-dot']]: true,
        [styles['pintxo-pagination-dot--selected']]: selected,
        [styles['pintxo-pagination-dot--unselected']]: unselected,
        [styles['pintxo-pagination-dot--edge']]: edge,
      })}
      aria-selected={selected}
      data-rtl={rtl}
      data-variant={variant}
      role="tab"
      style={transformEdge}
      type="button"
      {...(!selected ? { tabIndex: -1 } : {})}
      {...props}
    />
  )
}

export default PaginationDot
